import * as React from "react"
import { Text, Button, ButtonProps } from "@chakra-ui/react"
import { AiFillTwitterSquare } from "react-icons/ai"

type AdditionProps = {
  onlyIcon?: boolean
}

export const TwitterButton: React.FC<ButtonProps & AdditionProps> = React.memo(
  ({ onlyIcon, ...props }) => {
    return (
      <Button
        background="#00acee"
        color="white"
        marginTop="1rem"
        width="130px"
        _active={{}}
        _hover={{}}
        _focus={{}}
        {...props}
      >
        <AiFillTwitterSquare />
        {!onlyIcon && <Text marginLeft="0.5rem">Twitter</Text>}
      </Button>
    )
  }
)
